import { GetDamagedAdjusterAttachedDocumentImagesQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedAdjusterAttachedDocumentImages/getDamagedAdjusterAttachedDocumentImagesQuery.type';
import { getDamagedAdjusterAttachedDocumentImagesFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedAdjusterAttachedDocumentImages/getDamagedAdjusterAttachedDocumentImagesQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getDamagedAdjusterAttachedDocumentImagesQueryOptions = (
  params: GetDamagedAdjusterAttachedDocumentImagesQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['damagedAdjusterAttachedDocumentImages', params],
    queryFn: () => getDamagedAdjusterAttachedDocumentImagesFunction(params),
    enabled: true,
  });
};
